import Hero from "../components/Hero/Hero";
import Movies from "../components/Movies/Movies";

function Home() {

    return (
        <div>
            <Hero/>
            <Movies/>
        
        </div>
    );

}

export default Home;